import { Filter, ReferenceInput, SelectInput, TextInput, List } from 'react-admin';
import React from 'react';

export const WalletFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="global_users.email._ilike" alwaysOn />

    </Filter>
);
